





































































import {Component, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CSelect from '@/components/base/select/CSelect.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
@Component({
    components: {CNumberField, CCheckbox, CSelect, CEditDialog},
})
export default class PlywoodPriceListEditDialog extends Mixins(EditDialogMixin) {
    errorKeyList = {
        IdPlywoodGrade: 'IdPlywoodGrade',
        IdPlywoodSize: 'IdPlywoodSize',
        IdPlywoodSpecie: 'IdPlywoodSpecie',
        IdPlywoodSurface: 'IdPlywoodSurface',
        IdPlywoodThickness: 'IdPlywoodThickness',
    };
}
